// Static process.env.* refs are required so webpack DefinePlugin can inline
// values from .env.dev / .env.prod at build time.
// Dynamic access like process.env[key] does not work in browser bundles.

// API
export const HTTP_PROTOCOL = process.env.DME_HTTP_PROTOCOL || 'http';
export const API_HOST = process.env.DME_API_HOST || 'localhost:8000/api';
export const S3_URL = process.env.DME_S3_URL || 'localhost:8000/static';
export const STATIC_HOST = process.env.DME_STATIC_HOST || S3_URL;

// ElasticSearch
export const ES_URL = process.env.DME_ES_URL || '';
export const ES_USERNAME = process.env.DME_ES_USERNAME || '';
export const ES_PASSWORD = process.env.DME_ES_PASSWORD || '';

// Zoho (optional)
export const ZOHO_REDIRECT_URI = process.env.DME_ZOHO_REDIRECT_URI || '';
export const ZOHO_CLIENT_ID = process.env.DME_ZOHO_CLIENT_ID || '';
export const ZOHO_CLIENT_SECRET = process.env.DME_ZOHO_CLIENT_SECRET || '';
export const ZOHO_ORG_ID = process.env.DME_ZOHO_ORG_ID || '';



// WEBPACK FOOTER //
// src/config.js